/**
 * @description Initializes the JAM code snippet functionality.
 * Capture and manage code snippets effectively.
 * @returns {void}
 */
export const initialize_jam_code_snippet = () => {
  return new Promise((resolve, reject) => {
    // meta
    if (!document.querySelector('meta[name="jam:team"]')) {
      const meta = document.createElement("meta");
      meta.name = "jam:team";
      meta.content = "43204f5b-3a86-42c3-a33d-2d300e911222";
      document.head.appendChild(meta);
    }
    // recorder.js
    const recorder = document.createElement("script");
    recorder.type = "module";
    recorder.src = "https://js.jam.dev/recorder.js";
    recorder.onload = () => resolve("recorder loaded");
    recorder.onerror = reject;
    document.head.appendChild(recorder);

    // capture.js
    const capture = document.createElement("script");
    capture.type = "module";
    capture.src = "https://js.jam.dev/capture.js";
    capture.onload = () => resolve("capture loaded");
    capture.onerror = reject;
    document.head.appendChild(capture);
  });
};
